function setAmount(windowWidth, maxAmount, tabletAmount, modileAmount, isAPI) {
  const maxWidth = isAPI ? 1600 : 1024;
  if (windowWidth !== 0 && windowWidth <= maxWidth && windowWidth > 700) return tabletAmount;

  if (windowWidth > maxWidth) return maxAmount;

  if (windowWidth <= 700) return modileAmount;
}

export default setAmount;
